import { CustomerCustomFieldDataType } from "@redotech/redo-model/customer-custom-fields/customer-custom-fields-definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const createCustomField = {
  name: "createCustomField" as const,
  input: z.object({
    name: z.string().min(1, "Field name is required"),
    dataType: z.nativeEnum(CustomerCustomFieldDataType),
    isMultiValued: z.boolean().default(false),
    options: z.array(z.string()).optional(),
  }),
  output: z.object({ success: z.boolean(), declarationId: zExt.objectId() }),
};
